import React, { useEffect, useState } from "react";
import Boardcard from "../../Components/Boardcard/Boardcard";
import ButtonPagenate from "../../Components/ButtonPagenate/ButtonPagenate";
import Navbar from "../../Components/Navbar/navbar";
import Topbarsub from "../../Components/Topbar/Topbarsub";
import "../Employee/employee.css";
import DepartmentList from "./departmentList";
import { GrEdit } from "react-icons/gr";
import { AiFillDelete } from "react-icons/ai";
import { useCookies } from "react-cookie";
import axios from "axios";
import RoleList from "../Role/roleList";
import { StaffFilter } from "../ListFunction/listfunction";

const Department = ({ sendnotice, page, addnewoverlay, empselect }) => {
  console.log(empselect.allDepartments);
  const [cookies] = useCookies(["Token"]);
  const [searchcriteria, setSearchcriteria] = useState("");
  const [department, setDepartment] = useState(empselect.allDepartments);
  const [nameSearch, setNameSearch] = useState("");
  const API = "https://staging.sabrecwa.com/staff";
  const [pageNumber, setPageNumber] = useState(0);
  //   const [loading, setLoading] = useState(true)
  //   const [ confirmresponse, setConfirmresponse] = useState(0)

  const itemsPerpage = 8;
  const pageCount = Math.ceil(department.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;

  const totalDept = department.length;
  console.log(totalDept); //Number of items to be displayed per page
  // [n, n+1, n+2, ...]
  const totalJD = RoleList.reduce(
    (sum, items) => (sum = sum + items.jd.length),
    0
  );

  const handleSearchCriteria = (incoming) => {
    setSearchcriteria(incoming);
  };

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    handleWidth();
    getDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDepartment = async () => {
    sendnotice("load");
    try {
      var config = {
        method: "GET",
        url: `${API}/hr/departments`,
        data: {},
        headers: {
          Authorization: "Bearer " + cookies.Token,
        },
      };

      console.log(config);

      await axios(config).then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          // do something
          sendnotice("closeloading");
          setDepartment(
            response.data.data !== null ? response.data.data : DepartmentList
          );
        } else {
          // do something
        }
      });
    } catch (e) {
      if (e.message.includes("401")) {
        // catch error
      } else {
        // catch error
      }
    }
  };

  const handleAddNewEmp = () => {};

  const filterSearch = (incoming) => {
    setNameSearch(incoming.toString());
  };

  var EmployeeLists = department.filter((filteredItem) => {
    if (searchcriteria === "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria === "" && nameSearch !== "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch !== "") {
      if (searchcriteria === "Fullname") {
        if (
          filteredItem.firstname
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Dept. Head") {
        if (
          filteredItem.designation
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Department") {
        if (
          filteredItem.department
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else {
        return filteredItem;
      }
    }
  });

  const newPagenum = (num) => {
    setPageNumber(num);
  };

  // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  const handleDelete = async (props) => {
    console.log(props);
    // setConfirmload(true)
    try {
      var config = {
        method: "PUT",
        url: `${API}/changeEmpactive/${props}`,
        data: {},
        headers: {
          Authorization: "Bearer " + cookies.Token,
        },
      };

      console.log(config);

      //   await axios(config).then((response) => {
      //   // console.log(response.data.data);
      //   if(response.data.success === true){
      //     // do something
      //   }else{
      //     // do something
      //   }});
    } catch (e) {
      if (e.message.includes("401")) {
        // catch error
      } else {
        // catch error
      }
    }
  };

  const handleEdit = (incoming) => {
    addnewoverlay(incoming);
    // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  };

  const handleaddOverlay = (incoming) => {
    addnewoverlay(incoming);
  };

  const [widthval, setWidthval] = useState({
    pie1: 0,
    pie2: 0,
  });

  const handleWidth = () => {
    setWidthval({ pie1: totalDept, pie2: totalJD });
  };

  return (
    <div className="employee-container">
      <Navbar tabtext="Department" currentab="others" />
      <Topbarsub
        serchCriteria={handleSearchCriteria}
        newEmployee={handleAddNewEmp}
        currrenTab={page}
        searchword={filterSearch}
        addoverlay={handleaddOverlay}
      />
      <div className="tretapp-card-container">
        <Boardcard
          val={widthval.pie1}
          name="Total Department"
          maxV={10}
          minV={0}
        />
        <Boardcard
          val={widthval.pie2}
          name="Job Descriptions"
          maxV={250}
          minV={0}
        />
      </div>

      <div className="tretapp-list-submitted">
        <div className="tapp-list-title-container">
          <span id="tapp-list-title">Department Lists</span>
        </div>
        <div className="comp-list-table-containerr">
          <table>
            <thead>
              <tr>
                <th scope="col">#ID</th>
                <th scope="col">Department</th>
                <th scope="col">Department Head</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {EmployeeLists.slice(
                pagesVisited,
                pagesVisited + itemsPerpage
              ).map((items) => (
                <tr>
                  <td data-label="#ID">{items.id}</td>
                  <td data-label="Departmnent">{items.name}</td>
                  <td data-label="Dept. Head">
                    {StaffFilter(empselect, items.department_head)}
                  </td>
                  {/* <td data-label="Dept. Head">{items.first_name + ' ' + items.last_name}</td> */}
                  <td data-label="Action">
                    <GrEdit
                      onClick={() =>
                        handleEdit({ tag: "newdepartment", ID: items.id })
                      }
                      id="butn-action"
                    />
                    <AiFillDelete
                      onClick={() => handleDelete(items.id)}
                      id="butn-action"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="papp-table-pgnate-contain">
            <button
              id="addbitn"
              onClick={() => handleaddOverlay({ tag: "newdepartment" })}
            >
              Add
            </button>
            <ButtonPagenate
              updatedPageNum={newPagenum}
              pageCount={pageCount}
              pageNumber={pageNumber}
              previousLabel="Prev"
              nextLabel="Next"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Department;
